// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import moment from 'moment'

import { SpanWithData } from '../../'

export const MessageTableItem = ({ message, identity, actionColumn, expandMessage, replyToMessage, onClick, messageIdentity }) => (
  <tr onClick={() => onClick(message.id)} className='clickable'>
    <td>
      {messageIdentity
        ? messageIdentity.fullName
        : 'Unknown'
      }
    </td>
    <td>
      <SpanWithData forField="MessageDirection" searchKey={message.direction} />
    </td>
    <td>
      <SpanWithData forField="MessageStatus" searchKey={message.status} />
    </td>
    <td>
      {moment().isSame(moment(message.timestamp), 'day')
        ? moment(message.timestamp).format('hh:mm a')
        : moment(message.timestamp).format('lll')
      }
    </td>
    <td>
      {message.messageType
        ? <SpanWithData forField="MessageMessageType" searchKey={message.messageType} />
        : "Unknown"
      }
    </td>
    <td>
      <div
        className='slds-truncate'
        style={{ width: '200px' }}>
        {message.content}
      </div>
    </td>
    {actionColumn &&
      <td>
        {messageIdentity !== null
          ? actionColumn.render(message.id, messageIdentity.id)
          : '-'
        }
      </td>
    }
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-sms-messages/MessageTableItem.js